import { Image, Text, View } from '@react-pdf/renderer';

import { TargetFunction, TargetType } from '../../../../../store/reducers/workspace.reducer.ts';
import { getPhotometricSymbolReactPdf } from '../../../../../utils/photometricSymbolsPdf.tsx';
import styles from './LayerDetailsStyles.ts';
import CheckMark from './svgs/CheckMark.tsx';
import FailMark from './svgs/FailMark.tsx';

interface LayerDetailsData {
  title: string;
  headerDescription: string;
  tableRows: {
    groupTitle: string;
    metrics: {
      symbol: TargetFunction;
      type: TargetType;
      unit: string;
      target: number;
      calculated: number;
      passed: boolean;
    }[];
  }[];
  images: Array<{
    photometry: string;
    url: string;
    graphType: string;
  }>;
}

interface LayerDetailsProps {
  layerDetailsData: LayerDetailsData;
}

const LayerDetails = ({ layerDetailsData }: LayerDetailsProps) => (
  <View style={styles.container}>
    <Text style={styles.titleContent}>{layerDetailsData.title}</Text>

    <View style={styles.table}>
      <View style={styles.tableHeader}>
        <Text style={[styles.headerCell, styles.headerColumn1]}> </Text>
        <Text style={[styles.headerCell, styles.headerColumnOthers]}>Symbol</Text>
        <Text style={[styles.headerCell, styles.headerColumnOthers]}>Calculated</Text>
        <Text style={[styles.headerCell, styles.headerColumnOthers]}>Target</Text>
        <Text style={[styles.headerCell, styles.headerColumnCheck]}>Check</Text>
      </View>

      {layerDetailsData.tableRows.map((row, rowIndex) => (
        <View key={rowIndex} style={styles.tableRow}>
          <View style={[styles.groupHeader]}>
            <Text>{row.groupTitle}</Text>
          </View>
          <View style={{ flex: 3.5 }}>
            {row.metrics.map((metric, metricIndex) => (
              <View key={metricIndex} style={styles.tableRowBody}>
                <Text style={styles.symbolCell}>{getPhotometricSymbolReactPdf(metric.symbol, metric.type)}</Text>
                <Text style={styles.regularCell}>
                  {metric.calculated.toFixed(2)} {metric.unit}
                </Text>
                <Text style={styles.regularCell}>
                  {metric.target.toFixed(2)} {metric.unit}
                </Text>
                <View style={styles.checkCell}>{metric.passed ? <CheckMark /> : <FailMark />}</View>
              </View>
            ))}
          </View>
        </View>
      ))}
    </View>

    <View style={styles.imageContent}>
      {layerDetailsData.images.map((image, index) => (
        <View key={index} style={{ marginBottom: 20 }} break={index > 0}>
          <Text style={{ fontSize: 12, marginBottom: 8, fontWeight: 'bold', textTransform: 'capitalize' }}>
            {image.graphType.replace(/_/g, ' ')} - {image.photometry.replace(/_/g, ' ')}
          </Text>
          <Image style={styles.descriptionImage} src={image.url} />
        </View>
      ))}
    </View>
  </View>
);

export default LayerDetails;
